import { createAction, props } from '@ngrx/store';
import { AppConfigValuesState } from '../app-config.state';

/**
 * Dispatched to (re)load the app config from the backend. Used for BOTH the initial boot load
 * and a refresh after a location-tracker save — the reducer sets `Loading` on every dispatch,
 * which is what makes the settle-wait in `awaitAppConfigSettled` correct on a refresh too.
 */
export const loadAppConfig = createAction('[AppConfig] Load');

/** Dispatched by the load effect once the backend GET succeeds. Triggers a persist of the slice. */
export const appConfigLoaded = createAction('[AppConfig] Loaded', props<{ values: AppConfigValuesState }>());

/**
 * Dispatched by the persistence bridge with the values read back from storage. Populates the
 * slice like {@link appConfigLoaded} but must NOT trigger a re-persist or change `status` — the
 * data came from storage in the first place, and `status` tracks the backend fetch only.
 */
export const appConfigLoadedFromStorage = createAction(
    '[AppConfig] Loaded from storage',
    props<{ values: AppConfigValuesState }>(),
);

/** Dispatched by the load effect when the backend GET fails. */
export const appConfigFailed = createAction('[AppConfig] Load failed');
